<template>
  <div class="container">
    <div class="text--base row">
      <Fundings :content="fundingsContent" />
    </div>
  </div>
</template>

<script>
import { json as fetchJson } from 'd3';
import Fundings from '@/components/content/Fundings.vue';

export default {
  name: 'App1BubbleCluster',
  components: {
    Fundings,
  },
  data() {
    return {
      content: {},
    };
  },
  computed: {
    fundingsContent() {
      return this.content.sections ? this.content.sections.find((d) => d.id === 'fundings') : {};
    }
  },
  async created() {
    this.content = await fetchJson(`${process.env.BASE_URL}data/content/chapter-01.json`);
  },
};
</script>